import { useNavigate, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useChat } from "@/context/ChatContext";

export const ChatWidget = () => {
  const { isInternal, unread } = useChat();
  const navigate = useNavigate();
  const location = useLocation();
  const pubblica = /^\/(adesione|area|informativa|videochiamata|sign|sign-form|consenso|q|ricevuta|firma-mup)\//.test(location.pathname);
  if (!isInternal || pubblica || location.pathname === "/chat") return null;

  const hasAlte = (unread.alte_aperte || 0) > 0;
  const total = unread.total || 0;

  return (
    <button
      data-testid="chat-fab"
      onClick={() => navigate("/chat")}
      className={`fixed bottom-6 right-6 z-[60] flex items-center gap-2 rounded-full pl-4 pr-5 py-3 shadow-lg text-white font-medium transition-transform hover:scale-105 ${hasAlte ? "bg-red-600 animate-pulse" : "bg-slate-900"}`}
      title="Chat interna staff"
    >
      <div className="relative">
        <MessageCircle className="h-5 w-5" />
        {total > 0 && (
          <span data-testid="chat-fab-badge" className={`absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full text-[11px] font-bold flex items-center justify-center ${hasAlte ? "bg-white text-red-600" : "bg-red-500 text-white"}`}>
            {total > 99 ? "99+" : total}
          </span>
        )}
      </div>
      <span className="text-sm">Chat{hasAlte ? " · PRIORITÀ" : ""}</span>
    </button>
  );
};
